import React from "react";

interface ColumnHeadProps {
  title: string;
}

export default function ColumnHead(props: ColumnHeadProps) {
  return <p className={"cursor-default select-none"}>{props.title}</p>;
}
